export default __webpack_public_path__ + "static/media/v2_about_bg.ac5e8972.png";